export { resource } from '@util/resource/resource';
